"use client"

import ConnectionCheckTable from "@/components/ConnectionCheckTable";
import { ConnectionStatus } from "@/constants/status";
import { ConnectionCheckSchema } from "@/schemas/connection-check.schema";
import { getNormalDomains } from "@/services/domains.service";
import { useEffect, useState } from "react";
import { z } from "zod";

export default function DomainsPage() {
    const [domains, setDomains] = useState<z.infer<typeof ConnectionCheckSchema>[]>([]);

    useEffect(() => {
        if(domains.length === 0){
            const loadAllDomains = async () => {
                const result = await getNormalDomains();
                const domains: z.infer<typeof ConnectionCheckSchema>[] = result.map((d) => { return {id: d.ID, name: d.Name, status: ConnectionStatus.standBy, website: d.Website, folder: d.Folder, admin: d.Admin, package: d.Package}});
                setDomains(domains);
            };

            loadAllDomains();
        }
    }, [domains]);

    return (
        <ConnectionCheckTable domains={domains}/>
    );
}
